module.exports = __webpack_public_path__ + "static/media/web-dev-junior-programmer-level.f7917ead.jpg";